import { render, staticRenderFns } from "./FiscalData.vue?vue&type=template&id=32d14a52"
import script from "./FiscalData.vue?vue&type=script&lang=js"
export * from "./FiscalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports